/**
 * Циклический буфер. Выделяет память один раз и перезаписывает данные по кругу,
 * заменяя самые старые записи на новые.
 */
export class CircularBuffer<T> {
    private itemsCount = 0;
    private readonly buffer: Array<T>;

    /** Количество сохраненных элементов */
    get size() {
        return Math.min(this.buffer.length, this.itemsCount);
    }

    constructor(private readonly capacity: number) {
        this.buffer = Array<T>(capacity);
    }

    /** Итерируется по всем элементам от самого старого, до самого нового */
    *[Symbol.iterator]() {
        for (let bufferIndex = this.size; bufferIndex > 0; bufferIndex--) {
            const index = (this.itemsCount - bufferIndex) % this.capacity;

            const item = this.buffer[index];
            if (item) {
                yield item;
            }
        }
    }

    /** Добавляет элемент в конец буфера */
    push(value: T) {
        const index = this.itemsCount % this.capacity;
        this.buffer[index] = value;
        this.itemsCount++;
    }

    /** Заменяет последний добавленный элемент на переданный */
    replaceLast(value: T) {
        if (this.itemsCount === 0) {
            this.push(value);
            return;
        }

        const index = this.itemsCount - (1 % this.capacity);
        this.buffer[index] = value;
    }

    /** Очищает буфер */
    clear() {
        this.buffer.length = 0;
        this.itemsCount = 0;
    }
}
